import { render, staticRenderFns } from "./ChoiceAthleticEvents.vue?vue&type=template&id=92458aa6&scoped=true&"
import script from "./ChoiceAthleticEvents.vue?vue&type=script&lang=js&"
export * from "./ChoiceAthleticEvents.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceAthleticEvents.vue?vue&type=style&index=0&id=92458aa6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92458aa6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VContainer,VRow})
